import { Organization as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type Organization = {
  id: number;
  name: string;
  default: boolean;
};

export const fromGql = (item: GQLItem): Organization =>
  take<Organization>(item, 'id', 'name', 'default');
